/* eslint-disable sort-keys */
export const urls: Record<
  'es',
  Record<string, '/l/es/es' | `/l/es/es/${string}`>
> = {
  es: {
    // Home
    '': '/l/es/es/home',

    // Alumni
    alumni: '/l/es/es/alumni',

    // B2B
    empresas: '/l/es/es/b2b',
    'empresas/contacto': '/l/es/es/b2b/apply',

    // Blog
    blog: '/l/es/es/blog',

    // Campus
    barcelona: '/l/es/es/campus/bcn',
    madrid: '/l/es/es/campus/mad',
    remoto: '/l/es/es/campus/rmt',

    // Career
    'apoyo-profesional': '/l/es/es/career',

    // Courses
    'desarrollo-web': '/l/es/es/course/wd',
    'data-analytics': '/l/es/es/course/da',
    'diseno-ux-ui': '/l/es/es/course/ux',
    ciberseguridad: '/l/es/es/course/cy',

    // FAQ
    'preguntas-frecuentes': '/l/es/es/faq',

    // Financing Options
    financiacion: '/l/es/es/financing',

    // Forms
    'solicitar-plaza': '/l/es/es/apply',
    'solicitar-plaza2': '/l/es/es/full-apply',
    contacto: '/l/es/es/contact',
    'formulario-financiacion': '/l/es/es/financing-form',
    gracias: '/l/es/es/thank-you',
    gracias2: '/l/es/es/thank-you-dynamic',

    // Quiz
    quiz: '/l/es/es/quiz',
    'inteligencia-artificial/match': '/l/es/es/quiz-match/ai',
    'ciberseguridad/match': '/l/es/es/quiz-match/cy',
    'data-analytics/match': '/l/es/es/quiz-match/da',
    'devops-cloud-computing/match': '/l/es/es/quiz-match/dv',
    'marketing-digital/match': '/l/es/es/quiz-match/mk',
    'data-science-machine-learning/match': '/l/es/es/quiz-match/ml',
    'diseno-ux-ui/match': '/l/es/es/quiz-match/ux',
    'desarrollo-web/match': '/l/es/es/quiz-match/wd',

    // Syllabus Forms
    'ciberseguridad/plan-de-estudios': '/l/es/es/syllabus/cy',
    'data-analytics/plan-de-estudios': '/l/es/es/syllabus/da',
    'diseno-ux-ui/plan-de-estudios': '/l/es/es/syllabus/ux',
    'desarrollo-web/plan-de-estudios': '/l/es/es/syllabus/wd',
    'data-science-machine-learning/plan-de-estudios': '/l/es/es/syllabus/ml',
    'inteligencia-artificial/plan-de-estudios': '/l/es/es/syllabus/ai',
    'devops-cloud-computing/plan-de-estudios': '/l/es/es/syllabus/dv',
    'marketing-digital/plan-de-estudios': '/l/es/es/syllabus/mk',

    // Legal Pages
    'aviso-legal': '/l/es/es/privacy',
    'terminos-condiciones': '/l/es/es/terms',

    // PDP
    'desarrollo-web/barcelona': '/l/es/es/pdp/wd/bcn',
    'desarrollo-web/madrid': '/l/es/es/pdp/wd/mad',
    'desarrollo-web/remoto': '/l/es/es/pdp/wd/rmt',
    'data-analytics/barcelona': '/l/es/es/pdp/da/bcn',
    'data-analytics/madrid': '/l/es/es/pdp/da/mad',
    'data-analytics/remoto': '/l/es/es/pdp/da/rmt',
    'diseno-ux-ui/barcelona': '/l/es/es/pdp/ux/bcn',
    'diseno-ux-ui/madrid': '/l/es/es/pdp/ux/mad',
    'diseno-ux-ui/remoto': '/l/es/es/pdp/ux/rmt',
    'ciberseguridad/barcelona': '/l/es/es/pdp/cy/bcn',
    'ciberseguridad/madrid': '/l/es/es/pdp/cy/mad',
    'ciberseguridad/remoto': '/l/es/es/pdp/cy/rmt',
    'data-science-machine-learning/remoto': '/l/es/es/pdp/ml/rmt',
    'inteligencia-artificial/remoto': '/l/es/es/pdp/ai/rmt',
    'devops-cloud-computing/remoto': '/l/es/es/pdp/dv/rmt',
    'marketing-digital/remoto': '/l/es/es/pdp/mk/rmt',
  },
};
/* eslint-enable sort-keys */
